/**
 * Replace URL without refresh
 * @replace replaces instead of pushing new url
 */

const modifyURL = (url: string, replace?: boolean) => {
  if (replace) {
    window.history.replaceState(window.history.state, "", url);
  } else {
    window.history.pushState(window.history.state, "", url);
  }
};

export default modifyURL;
